// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  useColorMode,
  useColorModeValue,
  Stat,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";

import {
  UserOutlined,
  MailOutlined,
  ScheduleOutlined,
  EnvironmentOutlined,
  BankOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
// Assets
import BackgroundCard1 from "assets/img/BackgroundCard1.png";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import IconBox from "components/Icons/IconBox";
import { MastercardIcon, VisaIcon } from "components/Icons/Icons";
import { HSeparator } from "components/Separator/Separator";
import BillingRow from "components/Tables/BillingRow";
import InvoicesRow from "components/Tables/InvoicesRow";
import TransactionRow from "components/Tables/TransactionRow";
import React, { useEffect, useState } from "react";
import {
  FaPaypal,
  FaPencilAlt,
  FaRegCalendarAlt,
  FaWallet,
  FaHandHoldingUsd,
  FaClock,
} from "react-icons/fa";
import { RiMastercardFill } from "react-icons/ri";
import {
  billingData,
  invoicesData,
  newestTransactions,
  olderTransactions,
} from "variables/general";

import paypallogo from "../../img/paypal.png";
import zellelogo from "../../img/zelle.webp";
import banklogo from "../../img/bank.png";
import { Input } from "antd";

import { Modal, Segmented } from "antd";
import { message } from "antd";
import { Col, Row, Statistic } from "antd";
import { Select } from "antd";
import CountUp from "react-countup";

const formatter = (value) => <CountUp end={value} separator="," />;

function Billing() {
  // Chakra color mode
  const iconBlue = useColorModeValue("blue.500", "blue.500");
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#dee2e6", "transparent");
  const { colorMode } = useColorMode();

  const [cuentas, setCuentas] = useState([]);

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const [saldo, setSaldo] = useState(0);
  const [totalg, setTotalg] = useState(0);
  const [cuentaselect, setCuentaselect] = useState(0);

  const [confirmLoading, setConfirmLoading] = useState(false);
  const [confirmLoading2, setConfirmLoading2] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const [selectedOption, setSelectedOption] = useState("Paypal");

  const [messageApi, contextHolder] = message.useMessage();

  const [pendientes, setPendientes] = useState([]);
  const [pagados, setPagados] = useState([]);
  const [miscuentas, setMiscuentas] = useState([]);

  const actualizarcuenta = (tipo) => {
    if (tipo == "actualizar") {
      obtenercuentas();
    }
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Account successfully saved",
    });
  };
  const success2 = () => {
    messageApi.open({
      type: "success",
      content:
        "Successfully Withdrawn! Payments are made at the beginning of each month.",
    });
  };

  const error_empty = () => {
    messageApi.open({
      type: "error",
      content: "Complete the form",
    });
  };

  const error_general = (msj) => {
    messageApi.open({
      type: "error",
      content: msj,
    });
  };

  const error_cuentas = () => {
    messageApi.open({
      type: "error",
      content: "select an account to withdraw",
    });
  };

  const error_saldo = () => {
    messageApi.open({
      type: "error",
      content: "Minimum Quantity 30 USD",
    });
  };

  const error_email_invalid = () => {
    messageApi.open({
      type: "error",
      content: "Enter a valid Email",
    });
  };

  const showModal = () => {
    setOpen(true);
  };
  const showModal2 = () => {
    setOpen2(true);
    setCuentaselect(0);
  };
  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let type_error = "";
    let emailt = "";
    let namet = "";
    let addresst = "";

    if (selectedOption == "Paypal" || selectedOption == "Zelle") {
      emailt = document.getElementById("account-add").value;
    }

    console.log("EL EMAIL ES " + emailt);

    if (selectedOption == "Bank") {
      emailt = document.getElementById("account-add").value;
      namet = document.getElementById("name-add").value;
      addresst = document.getElementById("address-add").value;
    }

    if (selectedOption == "Paypal" || selectedOption == "Zelle") {
      if (emailt == "") {
        type_error = "vacio";
      } else if (!emailRegex.test(emailt)) {
        type_error = "email";
      }
    }

    if (selectedOption == "Bank") {
      if (emailt == "" || namet == "" || addresst == "") {
        type_error = "vacio";
      }
    }

    if (type_error === "vacio") {
      error_empty();
      setConfirmLoading(false);
      return;
    }

    if (type_error === "email") {
      console.log(type_error);
      error_email_invalid();
      setConfirmLoading(false);
      return;
    }

    const data = {
      token: localStorage.getItem("token_royal"),
      tipo: selectedOption,
      cuenta: emailt,
      ruta_bancaria: namet,
      direccion: addresst,
    };

    fetch(`${process.env.REACT_APP_API}/addcuentaswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          if (result.message == "guardado") {
            setConfirmLoading(false);
            setOpen(false);
            obtenercuentas();
            success();
            if (selectedOption == "Paypal") {
              setSelectedOption("Zelle");
            } else {
              setSelectedOption("Paypal");
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleOk2 = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading2(true);

    if (cuentaselect == 0) {
      error_cuentas();
      setConfirmLoading2(false);
      return;
    }

    if (saldo < 30) {
      error_saldo();
      setConfirmLoading2(false);
      return;
    }

    const data = {
      token: localStorage.getItem("token_royal"),
      cuenta: cuentaselect,
    };

    fetch(`${process.env.REACT_APP_API}/cashoutwill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.message) {
          if (result.message == "guardado") {
            setConfirmLoading2(false);
            setOpen2(false);
            obtenerpendiente();
            obtenersaldo();
            success2();
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          }
        } else {
          error_general(result.message);
          setConfirmLoading2(false);
          setOpen2(false);
          obtenerpendiente();
          obtenersaldo();

          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(error);
        error_general(result.message);
        setConfirmLoading2(false);
        setOpen2(false);
        obtenerpendiente();
        obtenersaldo();

        setTimeout(() => {
          window.location.reload();
        }, 3000);
      });
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };
  const handleCancel2 = () => {
    console.log("Clicked cancel button");
    setOpen2(false);
  };

  const handleSegmentChange = (value) => {
    console.log("Selected Payment Method:", value);
    setSelectedOption(value);
  };

  const handleSelectCuenta = (value) => {
    console.log("Selected Payment Method:", value);
    setCuentaselect(value);
  };

  const obtenercuentas = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };

    console.log(data);
    fetch(`${process.env.REACT_APP_API}/vercuentaswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result) {
          if (result.length > 0) {
            setCuentas(result);
          } else {
            setCuentas([]);
            if (result.message) {
              if (result.message == "Access Denied") {
                console.log(result.message);
                window.location.href = "/#/auth/signin";
                window.location.reload();
              }
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenersaldo = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/versaldowill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setSaldo(parseFloat(result.message));
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenerpendiente = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/verpendienteswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setPendientes(result.message);
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenerpagados = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/verpagadoswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setPagados(result.message);
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenerganado = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/vertotalganadowill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            } else {
              setTotalg(parseFloat(result.message));
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  console.log(colorMode);

  useEffect(() => {
    obtenercuentas();
    obtenersaldo();
    obtenerganado();
    obtenerpendiente();
    obtenerpagados();
  }, []);

  useEffect(() => {
    if (open == true) {
      if (selectedOption == "Paypal" || selectedOption == "Zelle") {
        document.getElementById("account-add").value = "";
      } else {
        document.getElementById("account-add").value = "";
        document.getElementById("name-add").value = "";
        document.getElementById("address-add").value = "";
      }
    }
  }, [open]);

  useEffect(() => {
    console.log(cuentas);
    let lascuentas = [];
    for (let i = 0; i < cuentas.length; i++) {
      lascuentas.push({
        value: cuentas[i].ID,
        label: cuentas[i].Tipo + " - " + cuentas[i].Cuenta,
      });
    }
    setMiscuentas(lascuentas);
  }, [cuentas]);

  useEffect(() => {
    console.log(cuentaselect);
  }, [cuentaselect]);

  const obtenertoken = () => {
    const isAuthenticated = localStorage.getItem("token_royal");

    console.log(window.location.hash);
    if (!isAuthenticated) {
      window.location.href = "/#/auth/signin";
      window.location.reload();
    }
  };

  useEffect(() => {
    obtenertoken();
  }, []);

  useEffect(() => {
    console.log("EL VALOR ES: " + selectedOption);
  }, [selectedOption]);

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Grid templateColumns={{ sm: "1fr", lg: "2fr 1.2fr" }} templateRows="1fr">
        <Box>
          <Grid
            templateColumns={{
              sm: "1fr",
              md: "1fr 1fr",
              xl: "1fr 1fr 1fr 1fr",
            }}
            templateRows={{ sm: "auto auto auto", md: "1fr auto", xl: "1fr" }}
            gap="26px"
          >
            <Card p="16px" display="flex" align="center" justify="center">
              <CardBody>
                <Flex direction="column" align="center" w="100%" py="14px">
                  <IconBox as="box" h={"60px"} w={"60px"} bg={iconBlue}>
                    <Icon h={"24px"} w={"24px"} color="white" as={FaWallet} />
                  </IconBox>
                  <Flex
                    direction="column"
                    m="14px"
                    justify="center"
                    textAlign="center"
                    align="center"
                    w="100%"
                  >
                    <Text fontSize="md" color={textColor} fontWeight="bold">
                      Current Balance
                    </Text>
                    <Text
                      mb="24px"
                      fontSize="xs"
                      color="gray.400"
                      fontWeight="semibold"
                    >
                      Available
                    </Text>
                    <HSeparator />
                  </Flex>
                  <Text fontSize="lg" color={textColor} fontWeight="bold">
                    ${saldo}
                  </Text>
                  <Modal
                    title="Retiro de Fondos"
                    open={open2}
                    onOk={handleOk2}
                    confirmLoading={confirmLoading2}
                    onCancel={handleCancel2}
                    okText="Cash Out"
                  >
                    <Row gutter={16}>
                      <Col span={12}>
                        <Statistic
                          title="Account Balance (USD)"
                          value={saldo}
                          precision={2}
                          formatter={formatter}
                          valueStyle={{ color: "green" }}
                        />
                      </Col>
                    </Row>

                    <br />

                    <div style={{ color: "#003366", fontSize: "16px" }}>
                      Seleccione tu Cuenta para el Retiro
                    </div>
                    <Select
                      placeholder="Account"
                      style={{ flex: 1, width: "100%" }}
                      options={miscuentas}
                      onChange={handleSelectCuenta}
                    />
                  </Modal>
                  <Button
                    onClick={() => {
                      showModal2();
                    }}
                    maxH="40px"
                    bg="green.500"
                    color="white"
                    _hover={{ bg: "green.600" }}
                    fontSize="sm" // Tamaño de letra
                  >
                    Cash Out
                  </Button>
                </Flex>
              </CardBody>
            </Card>
            <Card p="16px" display="flex" align="center" justify="center">
              <CardBody>
                <Flex
                  direction="column"
                  align="center"
                  justify="center"
                  w="100%"
                  py="14px"
                >
                  <IconBox as="box" h={"60px"} w={"60px"} bg={iconBlue}>
                    <Icon
                      h={"24px"}
                      w={"24px"}
                      color="white"
                      as={FaHandHoldingUsd}
                    />
                  </IconBox>
                  <Flex
                    direction="column"
                    m="14px"
                    justify="center"
                    textAlign="center"
                    align="center"
                    w="100%"
                  >
                    <Text fontSize="md" color={textColor} fontWeight="bold">
                      Withdrawn
                    </Text>
                    <Text
                      mb="24px"
                      fontSize="xs"
                      color="gray.400"
                      fontWeight="semibold"
                    >
                      Money exchanged
                    </Text>
                    <HSeparator />
                  </Flex>
                  <Text fontSize="lg" color={textColor} fontWeight="bold">
                    ${totalg}
                  </Text>
                </Flex>
              </CardBody>
            </Card>
          </Grid>
          <Card my={{ lg: "24px" }} me={{ lg: "24px" }}>
            {contextHolder}
            <Flex direction="column">
              <CardHeader py="12px">
                <Flex align="center" justify="space-between" p="22px">
                  <Text color={textColor} fontSize="lg" fontWeight="bold">
                    Billing Information
                  </Text>
                  <Button
                    onClick={() => {
                      showModal();
                    }}
                    variant="primary"
                    maxH="30px"
                  >
                    Add
                  </Button>

                  <Modal
                    title="Account Registration"
                    open={open}
                    onOk={handleOk}
                    confirmLoading={confirmLoading}
                    onCancel={handleCancel}
                    okText="Register Account"
                  >
                    <Segmented
                      options={[
                        {
                          label: (
                            <div style={{ padding: 4 }}>
                              <img src={paypallogo} width="30px" />
                              <div>PayPal</div>
                            </div>
                          ),
                          value: "Paypal",
                        },
                        {
                          label: (
                            <div style={{ padding: 4 }}>
                              <img src={zellelogo} width="30px" />
                              <div>Zelle</div>
                            </div>
                          ),
                          value: "Zelle",
                        },
                        {
                          label: (
                            <div style={{ padding: 4 }}>
                              <img src={banklogo} width="30px" />
                              <div>Bank</div>
                            </div>
                          ),
                          value: "Bank",
                        },
                      ]}
                      onChange={handleSegmentChange} // Maneja el cambio
                      defaultValue="Paypal"
                      value={selectedOption}
                    />
                    {selectedOption == "Paypal" ? (
                      <div>
                        <br />
                        <div align="center" style={{ fontSize: "14px" }}>
                          <strong>Account PayPal</strong>
                        </div>

                        <span style={{ fontSize: "14px", marginTop: "10px" }}>
                          Please enter your PayPal:
                        </span>
                        <Input
                          size="large"
                          id="account-add"
                          placeholder="Email"
                          defaultValue=""
                          prefix={<MailOutlined />}
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                    {selectedOption == "Zelle" ? (
                      <div>
                        <br />
                        <div align="center" style={{ fontSize: "14px" }}>
                          <strong>Account Zelle</strong>
                        </div>

                        <span style={{ fontSize: "14px", marginTop: "10px" }}>
                          Please enter your Zelle:
                        </span>
                        <Input
                          size="large"
                          id="account-add"
                          defaultValue=""
                          placeholder="Email"
                          prefix={<ScheduleOutlined />}
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                    {selectedOption == "Bank" ? (
                      <div>
                        <br />
                        <div align="center" style={{ fontSize: "14px" }}>
                          <strong>Account Bank</strong>
                        </div>

                        <span style={{ fontSize: "14px", marginTop: "10px" }}>
                          Bank Name:
                        </span>
                        <Input
                          size="large"
                          id="name-add"
                          placeholder="Bank Name"
                          defaultValue=""
                          prefix={<FileTextOutlined />}
                        />
                        <br />
                        <span style={{ fontSize: "14px", marginTop: "15px" }}>
                          Account Number:
                        </span>
                        <Input
                          size="large"
                          id="account-add"
                          placeholder="#"
                          defaultValue=""
                          prefix={<BankOutlined />}
                        />
                        <span style={{ fontSize: "14px", marginTop: "10px" }}>
                          Address:
                        </span>
                        <br />
                        <Input
                          size="large"
                          id="address-add"
                          placeholder="Address"
                          defaultValue=""
                          prefix={<EnvironmentOutlined />}
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </Modal>
                </Flex>
              </CardHeader>
              <CardBody>
                <Flex direction="column" w="100%">
                  {cuentas.length == 0 ? (
                    <div align="center" style={{ padding: "20px" }}>
                      <Stat me="auto">
                        <StatLabel
                          fontSize="xs"
                          color="gray.400"
                          fontWeight="bold"
                          textTransform="uppercase"
                        >
                          No Accounts registered
                        </StatLabel>
                      </Stat>
                    </div>
                  ) : (
                    <>
                      {cuentas.map((row, key) => {
                        return (
                          <>
                            <BillingRow
                              name={row.Tipo}
                              company={row.Ruta_Bancaria}
                              email={row.Cuenta}
                              number={row.Cuenta}
                              address={row.Direccion}
                              id={row.ID}
                              key={key}
                              actualizarcuenta={actualizarcuenta}
                            />
                          </>
                        );
                      })}
                    </>
                  )}
                </Flex>
              </CardBody>
            </Flex>
          </Card>
        </Box>

        {/* <Card
          p="22px"
          my={{ sm: "24px", lg: "0px" }}
          ms={{ sm: "0px", lg: "24px" }}
        >
          <CardHeader>
            <Flex justify="space-between" align="center" mb="1rem" w="100%">
              <Text fontSize="lg" color={textColor} fontWeight="bold">
                Invoices
              </Text>
              <Button
                variant="outlined"
                color={colorMode === "dark" && "white"}
                borderColor={colorMode === "dark" && "white"}
                _hover={colorMode === "dark" && "none"}
                minW="110px"
                maxH="35px"
              >
                VIEW ALL
              </Button>
            </Flex>
          </CardHeader>
          <CardBody>
            <Flex direction="column" w="100%">
              {invoicesData.map((row, idx) => {
                return (
                  <InvoicesRow
                    date={row.date}
                    code={row.code}
                    price={row.price}
                    logo={row.logo}
                    format={row.format}
                    key={idx}
                  />
                );
              })}
            </Flex>
          </CardBody>
        </Card> */}
        <Card ms={{ lg: "24px" }} mt={{ sm: "24px", lg: "0px" }}>
          <CardHeader mb="12px">
            <Flex direction="column" w="100%">
              <Flex
                direction={{ sm: "column", lg: "row" }}
                justify={{ sm: "center", lg: "space-between" }}
                align={{ sm: "center" }}
                w="100%"
                my={{ md: "12px" }}
              >
                <Text
                  color={textColor}
                  fontSize={{ sm: "lg", md: "xl", lg: "lg" }}
                  fontWeight="bold"
                >
                  Your Transactions
                </Text>
                <Flex align="center">
                  <Icon
                    as={FaRegCalendarAlt}
                    color="gray.400"
                    fontSize="md"
                    me="6px"
                  ></Icon>
                  <Text color="gray.400" fontSize="sm" fontWeight="semibold">
                    Todas
                  </Text>
                </Flex>
              </Flex>
            </Flex>
          </CardHeader>
          <CardBody>
            <Flex direction="column" w="100%">
              <Text
                color="gray.400"
                fontSize={{ sm: "sm", md: "md" }}
                fontWeight="semibold"
                my="12px"
              >
                PENDING
              </Text>
              {pendientes.map((row, idx) => {
                return (
                  <TransactionRow
                    name={row.Tipo}
                    date={row.Fecha}
                    price={row.Monto}
                    estatus={row.Estatus}
                    adjuntos={row.Adjuntos}
                    key={idx}
                  />
                );
              })}
              <Text
                color="gray.400"
                fontSize={{ sm: "sm", md: "md" }}
                fontWeight="semibold"
                my="12px"
              >
                PAID
              </Text>
              {pagados.map((row, idx) => {
                return (
                  <TransactionRow
                    name={row.Tipo}
                    date={row.Fecha}
                    price={row.Monto}
                    estatus={row.Estatus}
                    adjuntos={row.Adjuntos}
                    key={idx}
                  />
                );
              })}
            </Flex>
          </CardBody>
        </Card>
      </Grid>
    </Flex>
  );
}

export default Billing;
